/* @flow */
import React from 'react'
import { Marker } from 'react-google-maps'
// import { FaClose } from 'react-icons/lib/fa'
// import Preview from '../Preview'

type MarkerProps = {
  scene: Object,
  divingMode: Boolean,
  onInfoClick: Function
}
class SceneMarker extends React.Component<MarkerProps> {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }

    this.onToggleOpen = this.onToggleOpen.bind(this)
  }
  onToggleOpen() {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render() {
    const { locale, scene, divingMode, onClick, selected } = this.props
    return <Marker key={scene.name[locale] || scene.name}
      position={scene.latlng}
      onClick={() => {
        !divingMode && this.onToggleOpen()
        onClick(scene)
      }}
      opacity={selected ? 1 : 0.6}
      icon={{
        url: (divingMode ?
          'https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fmarker-360.svg?alt=media&token=9994c779-d1c2-4c54-ac43-73a3287edbb6' :
          'https://firebasestorage.googleapis.com/v0/b/caerulusvision.appspot.com/o/images%2Fmarker-shop.svg?alt=media&token=cc4eee5f-3a35-4ea7-8ae6-e69aeb0a3713'),
        size: new window.google.maps.Size(32, 32)
      }}>
      {/* { this.state.isOpen &&
        <InfoWindow
          onCloseClick={this.onToggleOpen}
          options={{ maxWidth: 280 }}>
          <div className="info-window-content" onClick={() => onInfoClick(scene)}>
            <div className="info-window-preview">
              <Preview
                locale={locale}
                subtitle={locationName}
                data={scene}
                options={[{
                  title: 'address',
                  value: scene.address[locale]
                }]}
              />
            </div>
            <FaClose className="close" size={18} onClick={e => this.onToggleOpen()} />
          </div>
        </InfoWindow>
      } */}
    </Marker>
  }
}

export default SceneMarker


// WEBPACK FOOTER //
// ./src/components/Map/SceneMarker.js